export const mercenariesList = {
  "Czarny Ork": {
    "id": 143,
    "startingEquipment": ["Sztylet","Rembak","Rembak","Broń wielka","Hełm","Ciężki"],
    "cost": 50,
    "pay": 25,
    "prestige": 32,
    "number": 1,
    "equipmentList": {

    },
    "type": "Najemne Ostrze",
    "stats": {
      "Początkowa": [4,4,3,4,4,2,2,1,8],
      "Maksymalna": [5,8,4,5,5,3,5,4,9]
    },
    "rules": ["Najemnik","Uzurpator","Zamknij ryj!","Zbrojny po zemby"],
    "exp": 0,
    "skills": [0,3,4,5]
  },
  "Grzybowar": {
    "id": 144,
    "startingEquipment": ["Sztylet","Kostur","Proca","Hełm"],
    "cost": 35,
    "pay": 15,
    "prestige": 13,
    "number": 1,
    "equipmentList": {

    },
    "type": "Najemne Ostrze",
    "stats": {
      "Początkowa": [4,2,3,3,3,1,3,1,6],
      "Maksymalna": [5,5,6,3,4,3,6,4,7]
    },
    "rules": ["Dziwnie cuchnom","Głupota","Grzybowar","Najemnik","Rozmiar rzondzi","Zawiść"],
    "exp": 0,
    "skills": [2,4,5]
  },
  Balistyk: {
    id: 101,
    startingEquipment: ["Sztylet", "Miecz", "Kusza", "Lekki"],
    cost: 80,
    pay: 40,
    prestige: 36,
    number: 1,
    equipmentList: {
      Balista: [0, 3, "Choice"],
      Katapulta: [0, 3, "Choice"],
    },
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [4, 3, 4, 3, 3, 1, 3, 1, 7],
      Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
    },
    rules: ["Drużyna obsługi", "Balistyk"],
    exp: 0,
    skills: [1, 5],
  },
  "Balistyk z Czarnej Arki": {
    id: 102,
    startingEquipment: [
      "Miecz",
      "Kusza powtarzalna",
      "Lekki",
      "Balista powtarzalna",
    ],
    cost: 95,
    pay: 40,
    prestige: 40,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [5, 4, 4, 3, 3, 1, 5, 1, 8],
      Maksymalna: [6, 7, 7, 4, 3, 3, 9, 4, 10],
    },
    rules: ["Drużyna obsługi", "Przyboczny", "Szósty zmysł", "Balistyk"],
    exp: 0,
    skills: [1, 5],
  },
  Bombardier: {
    id: 103,
    startingEquipment: ["Sztylet", "Miecz", "Muszkiet", "Lekki"],
    cost: 80,
    pay: 40,
    prestige: 36,
    number: 1,
    equipmentList: {
      Działo: [0, 3, "Choice"],
      Moździerz: [0, 3, "Choice"],
      Piekelnik: [0, 3, "Choice"],
      "Wyrzutnia rakiet": [0, 3, "Choice"],
    },
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [4, 3, 4, 3, 3, 1, 3, 1, 7],
      Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
    },
    rules: ["Drużyna obsługi", "Bombardier"],
    exp: 0,
    skills: [1, 5],
  },
  Czarownica: {
    id: 104,
    startingEquipment: ["Sztylet", "Kostur"],
    cost: 35,
    pay: 20,
    prestige: 21,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [4, 2, 2, 3, 3, 1, 3, 1, 6],
      Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
    },
    rules: ["Pomiot kniei", "Warzenie trucizn", "Wzgardzony", "Uroki"],
    exp: 0,
    skills: [2, 4, 5],
  },
  Gladiator: {
    id: 105,
    startingEquipment: ["Sztylet", "Miecz", "Karwasz bojowy", "Hełm"],
    cost: 30,
    pay: 15,
    prestige: 29,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [4, 4, 3, 4, 4, 1, 4, 2, 7],
      Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
    },
    rules: ["Szermierz", "Mistrz walki"],
    exp: 0,
    skills: [0, 3, 4, 5],
  },
  Goniec: {
    id: 106,
    startingEquipment: ["Sztylet", "Młot bojowy", "Kusza", "Hełm"],
    cost: 40,
    pay: 20,
    prestige: 21,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [3, 4, 4, 3, 4, 1, 2, 1, 9],
      Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
    },
    rules: [
      "Krzepki",
      "Nieustępliwość",
      "Odporność na magię (2)",
      "Pomiot podmroku",
      "Rankor",
      "Trudny do zabicia",
      "Uporczywość",
      "Wojownik podziemny",
      "Zabobonny lęk",
      "Goniec",
    ],
    exp: 0,
    skills: [1, 4, 5],
  },
  Gwardzista: {
    id: 107,
    startingEquipment: ["Sztylet", "Miecz", "Halabarda", "Ciężki", "Hełm"],
    cost: 45,
    pay: 20,
    prestige: 22,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [5, 5, 4, 3, 3, 1, 5, 1, 8],
      Maksymalna: [6, 7, 7, 4, 3, 3, 9, 4, 10],
    },
    rules: [
      "Krzepki",
      "Nienawiść",
      "Szósty zmysł",
      "Żywa tarcza",
      "Opiekun",
      "Ordynans",
    ],
    exp: 0,
    skills: [0, 3, 4, 5],
  },
  "Hiena cmentarna": {
    id: 108,
    startingEquipment: [
      "Sztylet",
      "Nadziak",
      "Latarnia sztormowa",
      "Lekki",
      "Lina & hak",
      "Wytrychy",
    ],
    cost: 40,
    pay: 20,
    prestige: 27,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
      Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
    },
    rules: ["Kamuflarz", "Wzgardzony", "Hiena cmentarna"],
    exp: 0,
    skills: [1, 4, 5],
  },
  Kanonier: {
    id: 109,
    startingEquipment: ["Młot bojowy", "Muszkiet krasnoludzki", "Lekki"],
    cost: 85,
    pay: 40,
    prestige: 41,
    number: 1,
    equipmentList: {
      Działo: [0, 3, "Choice"],
      "Działo ogniowe": [0, 3, "Choice"],
      Moździerz: [0, 3, "Choice"],
      Organki: [0, 3, "Choice"],
      Piekelnik: [0, 3, "Choice"],
      "Wyrzutnia rakiet": [0, 3, "Choice"],
    },
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [3, 4, 4, 3, 4, 1, 2, 1, 9],
      Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
    },
    rules: [
      "Drużyna obsługi",
      "Krzepki",
      "Nieustępliwość",
      "Szaniec",
      "Trudny do zabicia",
      "Uporczywość",
      "Zawiść",
      "Kanonier",
    ],
    exp: 0,
    skills: [1, 5],
  },
  Kartograf: {
    id: 110,
    startingEquipment: ["Sztylet", "Miecz", "Hełm", "Średni", "Luneta"],
    cost: 35,
    pay: 15,
    prestige: 15,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
      Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
    },
    rules: ["Mapy kartografa"],
    exp: 0,
    skills: [1, 4, 5],
  },
  Kupiec: {
    id: 111,
    startingEquipment: ["Sztylet", "Miecz"],
    cost: 40,
    pay: 20,
    prestige: 14,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
      Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
    },
    rules: ["Ekonom", "Handlarz"],
    exp: 0,
    skills: [2, 5],
  },
  Latarnik: {
    id: 112,
    startingEquipment: ["Sztylet", "Halabarda", "Lekki", "Latarnia sztormowa"],
    cost: 35,
    pay: 15,
    prestige: 13,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
      Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
    },
    rules: ["Latarnik"],
    exp: 0,
    skills: [1, 4, 5],
  },
  "Łowca czarownic": {
    id: 113,
    startingEquipment: [
      "Sztylet",
      "Miecz",
      "Pistolet pojedynkowy",
      "Pistolet pojedynkowy",
      "Średni",
    ],
    cost: 40,
    pay: 20,
    prestige: 27,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [4, 4, 3, 3, 3, 1, 4, 1, 8],
      Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
    },
    rules: ["Rajtar", "Spalić wiedźmę!"],
    exp: 0,
    skills: [0, 1, 4, 5],
  },
  "Łowca nagród": {
    id: 114,
    startingEquipment: ["Sztylet", "Miecz", "Pisolet", "Kusza", "Ciężki"],
    cost: 40,
    pay: 15,
    prestige: 31,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [4, 4, 3, 4, 3, 1, 4, 1, 8],
      Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
    },
    rules: ["Krzepki", "List gończy"],
    exp: 0,
    skills: [0, 1, 3, 4, 5],
  },
  Magus: {
    id: 115,
    startingEquipment: ["Sztylet", "Kostur", "Ładunki wybuchowe"],
    cost: 35,
    pay: 15,
    prestige: 10,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [4, 2, 2, 3, 3, 1, 3, 1, 6],
      Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
    },
    rules: ["Warzenie trucizn", "Wzgardzony", "Receptury"],
    exp: 0,
    skills: [2, 5],
  },
  Medyk: {
    id: 116,
    startingEquipment: ["Sztylet", "Trójząb", "Hełm"],
    cost: 35,
    pay: 15,
    prestige: 11,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
      Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
    },
    rules: ["Felczer"],
    exp: 0,
    skills: [2, 5],
  },
  Mekaniak: {
    id: 117,
    startingEquipment: ["Sztylet", "Bicz", "Kusza", "Lekki"],
    cost: 75,
    pay: 35,
    prestige: 41,
    number: 1,
    equipmentList: {
      Balista: [0, 3, "Choice"],
      Katapulta: [0, 3, "Choice"],
    },
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [4, 3, 4, 3, 4, 1, 2, 1, 7],
      Maksymalna: [5, 7, 5, 4, 5, 3, 5, 4, 8],
    },
    rules: ["Drużyna obsługi", "Mekaniak"],
    exp: 0,
    skills: [1, 5],
  },
  Minstrel: {
    id: 118,
    startingEquipment: ["Sztylet", "Rapier", "Łuk elfów", "Lekki"],
    cost: 40,
    pay: 20,
    prestige: 29,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [5, 4, 4, 3, 3, 1, 5, 1, 8],
      Maksymalna: [6, 7, 7, 4, 3, 3, 9, 4, 10],
    },
    rules: ["Pomiot kniei", "Szósty zmysł", "Sztuka łucznicza"],
    exp: 0,
    skills: [0, 1, 4, 5],
  },
  "Miotacz ołowiu": {
    id: 119,
    startingEquipment: ["Ołowiomiotacz", "Maczuga ogrów", "Lekki"],
    cost: 90,
    pay: 40,
    prestige: 67,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [6, 3, 2, 4, 4, 3, 2, 2, 7],
      Maksymalna: [6, 6, 5, 5, 5, 5, 6, 5, 9],
    },
    rules: [
      "Bycza szarża",
      "Duży cel",
      "Strach",
      "Tempy",
      "Wielkolud",
      "Gnoblar-pochodnia",
    ],
    exp: 0,
    skills: [1, 3, 5],
  },
  Ochroniarz: {
    id: 120,
    startingEquipment: ["Maczuga ogrów", "Karwasz bojowy", "Średni"],
    cost: 80,
    pay: 30,
    prestige: 58,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [6, 3, 2, 4, 4, 3, 2, 2, 7],
      Maksymalna: [6, 6, 5, 5, 5, 5, 6, 5, 9],
    },
    rules: [
      "Bycza szarża",
      "Duży cel",
      "Oznakowany gnoblar (gnoblar-uwaga)",
      "Strach",
      "Tempty",
      "Wielkolud",
    ],
    exp: 0,
    skills: [1, 3, 5],
  },
  Ogniomistrz: {
    id: 121,
    startingEquipment: ["Topór krasnoludów", "Muszkiet krasnoludzki", "Lekki"],
    cost: 90,
    pay: 40,
    prestige: 44,
    number: 1,
    equipmentList: {
      Balista: [0, 3, "Choice"],
      Działo: [0, 3, "Choice"],
      "Działo ogniowe": [0, 3, "Choice"],
      Katapulta: [0, 3, "Choice"],
      Moździerz: [0, 3, "Choice"],
      Organki: [0, 3, "Choice"],
    },
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [3, 4, 4, 3, 4, 1, 2, 1, 9],
      Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
    },
    rules: [
      "Drużyna obsługi",
      "Krzepki",
      "Nieustępliwość",
      "Odporność na magię (2)",
      "Pomiot podmroku",
      "Rankor",
      "Trudny do zabicia",
      "Uporczywość",
      "Wojownik podziemny",
      "Zabobonny lęk",
      "Ogniomistrz",
      "Szaniec",
    ],
    exp: 0,
    skills: [1, 5],
  },
  Ordynans: {
    id: 122,
    startingEquipment: ["Sztylet", "Miecz", "Łuk", "Lekki", "Tarcza"],
    cost: 35,
    pay: 15,
    prestige: 18,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
      Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
    },
    rules: ["Żywa tarcza", "Opiekun", "Ordynans"],
    exp: 0,
    skills: [0, 1, 5],
  },
  "Pogromca Trolli": {
    id: 123,
    startingEquipment: [
      "Topór krasnoludów",
      "Topór krasnoludów",
      "Broń wielka",
    ],
    cost: 25,
    pay: 10,
    prestige: 33,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [3, 4, 3, 3, 4, 1, 2, 1, 10],
      Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
    },
    rules: [
      "Fanatyk",
      "Krzepki",
      "Ochronne tatuaże",
      "Nieustępliwość",
      "Odporność na magię (2)",
      "Pomiot podmroku",
      "Rankor",
      "Pogromca",
      "Trudny do zabicia",
      "Uporczywość",
      "Wojownik podziemny",
      "Zabobonny lęk",
    ],
    exp: 0,
    skills: [0, 3],
  },
  "Porywacz zwłok": {
    id: 124,
    startingEquipment: [
      "Sztylet",
      "Topór bojowy",
      "Latarnia sztormowa",
      "Lekki",
      "Lina & hak",
    ],
    cost: 30,
    pay: 10,
    prestige: 16,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
      Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
    },
    rules: ["Kamuflaż", "Wzgardzony", "Porywacz zwłok"],
    exp: 0,
    skills: [3, 4, 5],
  },
  "Poszukiwacz złota": {
    id: 125,
    startingEquipment: [
      "Sztylet",
      "Nadziak",
      "Młot bojowy",
      "Hełm",
      "Pancerz z Gromrilu",
      "Mapa skarbów",
      "Latarnia sztormowa",
    ],
    cost: 55,
    pay: 30,
    prestige: 28,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [3, 5, 4, 3, 4, 1, 2, 1, 9],
      Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
    },
    rules: [
      "Krzepki",
      "Nieustępliwość",
      "Odporność na magię (2)",
      "Pomiot podmroku",
      "Rankor",
      "Pogromca",
      "Trudny do zabicia",
      "Uporczywość",
      "Wojownik podziemny",
      "Zabobonny lęk",
      "Mapa skarbów",
    ],
    exp: 0,
    skills: [1, 3],
  },
  Rozbójnik: {
    id: 126,
    startingEquipment: [
      "Sztylet",
      "Pistolet",
      "Pistolet",
      "Rapier",
      "Płaszcz (puklerz)",
      "Koń bojowy",
      "Siodło & uprząż",
    ],
    cost: 35,
    pay: 20,
    prestige: 35,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [4, 3, 4, 3, 3, 1, 3, 2, 7],
      Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      "Koń bojowy": [8, 3, 0, 3, "-", "-", 3, 1, 5],
    },
    rules: [
      "Kawalerzysta",
      "Lekka jazda",
      "Rajtar",
      "Celny strzał",
      "Rozbójnik",
    ],
    exp: 0,
    skills: [0, 1, 4, 5],
  },
  "Rycerz najemny": {
    id: 127,
    startingEquipment: [
      "Sztylet",
      "Miecz",
      "Kopia",
      "Tarcza",
      "Ciężki",
      "Koń bojowy",
      "Siodło & uprząż",
    ],
    cost: 50,
    pay: 20,
    prestige: 32,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [4, 4, 3, 4, 3, 1, 4, 1, 7],
      Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      "Koń bojowy": [8, 3, 0, 3, "-", "-", 3, 1, 5],
    },
    rules: ["Duży cel (wierzchem)", "Kawalerzysta", "Krzepki"],
    exp: 0,
    skills: [0, 3, 5],
  },
  "Rycerz na Zimnokrwistym": {
    id: 128,
    startingEquipment: [
      "Sztylet",
      "Miecz",
      "Kopia",
      "Tarcza",
      "Ciężki",
      "Zimnokrwisty",
      "Siodło & uprząż",
    ],
    cost: 50,
    pay: 20,
    prestige: 40,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [5, 5, 4, 3, 3, 1, 5, 1, 8],
      Maksymalna: [6, 7, 7, 4, 3, 3, 9, 4, 10],
      Zimnokrwisty: [7, 3, 0, 4, 4, 1, 2, 1, 3],
    },
    rules: [
      "Duży cel (wierzchem)",
      "Kawalerzysta",
      "Krzepki",
      "Nienawiść",
      "Szósty zmysł",
      "Zimnokrwisty",
    ],
    exp: 0,
    skills: [0, 3, 5],
  },
  Skryba: {
    id: 129,
    startingEquipment: ["Sztylet", "Kaganek"],
    cost: 25,
    pay: 15,
    prestige: 5,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [4, 2, 2, 3, 3, 1, 3, 1, 6],
      Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
    },
    rules: ["Zwoje skryby"],
    exp: 0,
    skills: [2, 5],
  },
  "Strażnik dróg": {
    id: 130,
    startingEquipment: [
      "Sztylet",
      "Młot ulrykański",
      "Topór bojowy",
      "Broń miotana (topory)",
      "Kusza",
      "Średni",
      "Latarnia sztormowa",
      "Koń bojowy",
      "Siodło & uprząż",
    ],
    cost: 40,
    pay: 20,
    prestige: 37,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [4, 3, 4, 3, 3, 1, 3, 1, 8],
      Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      "Koń bojowy": [8, 3, 0, 3, "-", "-", 3, 1, 5],
    },
    rules: [
      "Duży cel (wierzchem)",
      "Kawalerzysta",
      "Bystry wzrok",
      "Celny strzał",
    ],
    exp: 0,
    skills: [0, 1, 3, 5],
  },
  "Strażnik Morski z Lothern": {
    id: 131,
    startingEquipment: ["Miecz", "Łuk długi", "Lekki", "Balista powtarzalna"],
    cost: 95,
    pay: 40,
    prestige: 40,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [5, 4, 4, 3, 3, 1, 5, 1, 8],
      Maksymalna: [6, 7, 7, 4, 3, 3, 9, 4, 10],
    },
    rules: ["Drużyna obsługi", "Przyboczny", "Szósty zmysł"],
    exp: 0,
    skills: [1, 5],
  },
  Szczelec: {
    id: 132,
    startingEquipment: ["Sztylet", "Bicz", "Łuk", "Lekki"],
    cost: 70,
    pay: 35,
    prestige: 41,
    number: 1,
    equipmentList: {
      Balista: [0, 3, "Choice"],
      Katapulta: [0, 3, "Choice"],
    },
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [4, 3, 4, 3, 3, 1, 3, 1, 6],
      Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
    },
    rules: ["Drużyna obsługi", "Szczelec"],
    exp: 0,
    skills: [1, 5],
  },
  Szczurogr: {
    id: 133,
    startingEquipment: ["Broń naturalna"],
    cost: 80,
    pay: 35,
    prestige: 41,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [6, 3, 3, 5, 4, 3, 4, 2, 5],
      Maksymalna: [6, 6, 0, 5, 5, 5, 6, 5, 7],
    },
    rules: [
      "Bycza szarża",
      "Duży cel",
      "Głód trzewi",
      "Murołaz",
      "Ograniczony",
      "Przepastne trzewia",
      "Stan niższy",
      "Strach",
      "Tempy",
      "Wielkolud",
      "Uwarunkowany",
    ],
    exp: 0,
    skills: [0, 3, 5],
  },
  Szczurołap: {
    id: 134,
    startingEquipment: [
      "Sztylet",
      "Miecz",
      "Proca",
      "Latarnia sztormowa",
      "Lina & hak",
    ],
    cost: 30,
    pay: 15,
    prestige: 28,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
      Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
    },
    rules: ["Kamuflaż", "Ranger", "Zastawianie pułapek", "Zwiadowca"],
    exp: 0,
    skills: [1, 4, 5],
  },
  Szpieg: {
    id: 135,
    startingEquipment: ["Sztylet", "Miecz", "Dmuchawka", "Broń miotana (noże)"],
    cost: 50,
    pay: 30,
    prestige: 38,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [4, 4, 4, 3, 3, 1, 4, 2, 8],
      Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
    },
    rules: ["Infiltracja", "Ranger", "Zatruty atak", "Zwiadowca"],
    exp: 0,
    skills: [0, 1, 4, 5],
  },
  "Tileański kusznik": {
    id: 136,
    startingEquipment: ["Sztylet", "Miecz", "Kusza", "Średni"],
    cost: 30,
    pay: 15,
    prestige: 21,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [4, 3, 4, 3, 3, 1, 3, 1, 7],
      Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
    },
    rules: ["Celny stzał", "Pewny strzał"],
    exp: 0,
    skills: [1, 4, 5],
  },
  Trefniś: {
    id: 137,
    startingEquipment: ["Sztylet", "Buława", "Hełm"],
    cost: 35,
    pay: "Specjalne",
    prestige: 20,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [4, 2, 2, 3, 3, 1, 4, 1, 6],
      Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
    },
    rules: [
      "Akrobata",
      "Niepokojący",
      "Podżegacz",
      "Szczęście",
      "Wiarus",
      "Wzgardzony",
      "Żołd",
    ],
    exp: 0,
    skills: [2, 4],
  },
  Woźnica: {
    id: 138,
    startingEquipment: ["Sztylet", "Miecz", "Bat"],
    cost: 35,
    pay: 15,
    prestige: 16,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
      Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
    },
    rules: ["Woźnica", "Cieśla"],
    exp: 0,
    skills: [0, 3, 5],
  },
  Wróżbita: {
    id: 139,
    startingEquipment: ["Sztylet", "Karty Tarota", "Luneta"],
    cost: 35,
    pay: "Specjalne",
    prestige: 10,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [4, 2, 2, 3, 3, 1, 3, 1, 6],
      Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
    },
    rules: ["Szczęście", "Światowiec", "Tarot", "Wzgardzony", "Żołd"],
    exp: 0,
    skills: [2, 5],
  },
  Złodziej: {
    id: 140,
    startingEquipment: [
      "Sztylet",
      "Miecz",
      "Broń miotana (noże)",
      "Lina & hak",
      "Wytrychy",
    ],
    cost: 25,
    pay: "Specjalne",
    prestige: 20,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [3, 2, 4, 2, 2, 1, 4, 1, 8],
      Maksymalna: [4, 5, 7, 3, 3, 3, 9, 4, 10],
    },
    rules: [
      "Kamuflaż",
      "Kieszonkowiec",
      "Odporność na magię (2)",
      "Śmigły",
      "Kucharz",
      "Żołd",
    ],
    exp: 0,
    skills: [1, 4, 5],
  },
  Zwadźca: {
    id: 141,
    startingEquipment: [
      "Sztylet",
      "Łamacz mieczy",
      "Pistolet pojedynkowy",
      "Pistolet pojedynkowy",
      "Płaszcz (puklerz)",
      "Średni",
    ],
    cost: 40,
    pay: 20,
    prestige: 34,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [4, 4, 3, 3, 3, 1, 4, 1, 7],
      Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
    },
    rules: ["Szermierz", "Zabójczy cios", "Kult miecza & walki"],
    exp: 0,
    skills: [0, 1, 4, 5],
  },
  Zwiadowca: {
    id: 142,
    startingEquipment: [
      "Sztylet",
      "Miecz",
      "Łuk",
      "Broń miotana (topory)",
      "Kociołek (hełm)",
      "Lina & hak",
    ],
    cost: 25,
    pay: 10,
    prestige: 25,
    number: 1,
    equipmentList: {},
    type: "Najemne Ostrze",
    stats: {
      Początkowa: [3, 2, 4, 2, 2, 1, 4, 1, 8],
      Maksymalna: [4, 5, 7, 3, 3, 3, 9, 4, 10],
    },
    rules: [
      "Kamuflaż",
      "Odporność na magię (2)",
      "Ranger",
      "Śmigły",
      "Zwiadowca",
      "Kucharz",
    ],
    exp: 0,
    skills: [1, 4, 5],
  },
};
